/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

export const ResourcesApiEnum = {
    GET_RESOURCES: (): string => {
        return '/resources/';
    }
};
